/*

window.zESettings = {
    webWidget: {
        contactOptions: {
            enabled: true
        },
        color: {
            theme: '#1C6DA1',
            launcher: '#1C6DA1',
            launcherText: '#fff',
            button: '#1C6DA1',
            header: '#1C6DA1'
        },
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        }
    }
};
 */
window.zESettings = {
    webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
        contactOptions: {
            enabled: true
        }
    }
};

//contact even when online - hides chat on INT'L sites - needs to be built for all intl

jQuery(document).ready(function ($) {

    if (window.location.href.indexOf(".co.uk") > -1 || window.location.href.indexOf("ubweb2uk") > -1) {
        console.log('intl: uk');
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">UK</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.co.uk/country-select"><i class="far fa-globe" aria-hidden="true"></i>UK<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/ie/") > -1 || window.location.href.indexOf(".ie") > -1 || window.location.href.indexOf("ubweb2ie") > -1) {
        window.zESettings = {
            webWidget: {
                chat: {
                    suppress: true
                },
                contactForm: {
                    attachments: true,
                    ticketForms: [{ id: 1500000845761 }]
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">IE</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.ie/country-select"><i class="far fa-globe" aria-hidden="true"></i>IE<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/la/" || window.location.href.indexOf(".it") > -1 || window.location.href.indexOf("ubweb2ie") > -1) > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">LA</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/la/country-select"><i class="far fa-globe" aria-hidden="true"></i>LA<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/mx/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">MX</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/pl/country-select"><i class="far fa-globe" aria-hidden="true"></i>MX<span class="sr-only"> - Wybierz swój kraj</span></a>');
    } else if (window.location.href.indexOf("/il/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">IL</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/il/country-select"><i class="far fa-globe" aria-hidden="true"></i>IL<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/pl/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">PL</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/pl/country-select"><i class="far fa-globe" aria-hidden="true"></i>PL<span class="sr-only"> - Wybierz swój kraj</span></a>');
    } else if (window.location.href.indexOf("/cn/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">中国</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/cn/country-select"><i class="far fa-globe" aria-hidden="true"></i>中国<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/de/") > -1 || window.location.href.indexOf(".de") > -1 || window.location.href.indexOf("ubweb2de") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },

                launcher: {
                    label: {
                        '*': 'Unterstützung'
                    }
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">DE</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com.de/country-select"><i class="far fa-globe" aria-hidden="true"></i>DE<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/au/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">AU</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/au/country-select"><i class="far fa-globe" aria-hidden="true"></i>AU<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/fr/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">FR</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/fr/country-select"><i class="far fa-globe" aria-hidden="true"></i>FR<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/es/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },

                launcher: {
                    label: {
                        '*': 'Contactar'
                    }
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">ES</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/es/country-select"><i class="far fa-globe" aria-hidden="true"></i>ES<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/se/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },

                launcher: {
                    label: {
                        '*': 'Understöd'
                    }
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">SE</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/se/country-select"><i class="far fa-globe" aria-hidden="true"></i>SE<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/it/") > -1 || window.location.href.indexOf(".it") > -1 || window.location.href.indexOf("ubweb2it") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },

                launcher: {
                    label: {
                        '*': 'Assistenza'
                    }
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">IT</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/it/country-select"><i class="far fa-globe" aria-hidden="true"></i>IT<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/ae/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">AE</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/ae/country-select"><i class="far fa-globe" aria-hidden="true"></i>AE<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/tw/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">臺灣</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/tw/country-select"><i class="far fa-globe" aria-hidden="true"></i>臺灣<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/nl/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },

                launcher: {
                    label: {
                        '*': 'Hulp nodig?'
                    }
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">RU</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/nl/country-select"><i class="far fa-globe" aria-hidden="true"></i>NL<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/ru/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },

                launcher: {
                    label: {
                        '*': 'помощь'
                    }
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">RU</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.com/ru/country-select"><i class="far fa-globe" aria-hidden="true"></i>RU<span class="sr-only"> - opens the country selection page</span></a>');
    } else if (window.location.href.indexOf("/ca/") > -1 || window.location.href.indexOf(".ca") > -1 || window.location.href.indexOf("ubweb2ca") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                //chat: {
                //suppress: true
                //},
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
        jQuery('span#select').replaceWith('<span id="select" style="margin-left:24px; position:absolute; top:3px; font-size:12px;">CA</span>');
        jQuery('.country-selection a').replaceWith('<a href="https://uppababy.ca/country-select"><i class="far fa-globe" aria-hidden="true"></i>CA<span class="sr-only"> - opens the country selection page</span></a>');
        //jQuery( "<p>CA</p>" ).appendTo( ".icon-globe a" );
    } else if (window.location.href.indexOf("/il/") > -1) {
        window.zESettings = {webWidget: {
        contactForm: {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        },
                chat: {
                    suppress: true
                },
                color: {
                    theme: '#1C6DA1',
                    launcher: '#1C6DA1',
                    launcherText: '#fff',
                    button: '#1C6DA1',
                    header: '#1C6DA1'
                }
            }
        };
    }
    //SET TO DEFAULT FORM IF NOT SET... Should probably just move the US default here as else, or better yet, define options per country and then set once.
    if(!window.zESettings.webWidget.hasOwnProperty('contactForm')){
        return false;
        console.log(window.zESettings);
        window.zESettings.webWidget.contactForm= {
            attachments: false,
            ticketForms: [{ id: 690368 }],
        };
    }

    $('.contact-link, .support-chat-open').on('click',function(e){
        e.preventDefault();
        zE.activate();
        setTimeout(setFocusZendeskPopup, 100);
    });
    function setFocusZendeskPopup() {
        var iframe = $("#webWidget")[0];
        if( iframe !== undefined ) {
            iframe.contentWindow.focus();
        }
    }
});